import Lines from "../../components/Lines";
import "./DynamicPage.scss";

const IQACDynamicPage = ({ title, content, secondtitle }) => {

    return (
        <section className="IQACDynamicPageMainContainer">
            <header style={{ paddingBottom: "10px" }}>
                <h2>{title}</h2>
                <div style={{ display: "flex" }}>
                    <span className="linesParent">
                        <Lines count={25} color="#116C4A" fontSize={2.3} spacing={0.1} thickness={700} />
                    </span>
                </div>
            </header>

            <article>
                <p>{content}</p>
            </article>

            <header>
                <h2>{secondtitle}</h2>
            </header>
        </section>
    );
};

export default IQACDynamicPage;
